import { OrderQuery } from '@/suppliers/_gen/gql'
import { createContext, useContext } from 'react'
import { StoreOrder as StoreOrderOld } from './useFetchStoreOrder'

export const OrderContext = createContext<
  | {
      storeOrderId: string
      storeOrder: Exclude<OrderQuery['storeOrder'], null>
      storeOrderOld: StoreOrderOld
      refetch: () => Promise<unknown>
    }
  | undefined
>(undefined)

export const useOrderContext = () => {
  const context = useContext(OrderContext)
  if (context === undefined) throw new Error('must be used within provider')
  return context
}
